import { GraphQLCampaign } from 'modules/campaigns/lib/types';

export const getCancelCampaignPayload = (campaign: GraphQLCampaign) => {
  const { id: campaignId } = campaign;

  return {
    campaignId,
  };
};
